import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store/store";
import { BrowserRouter } from "react-router-dom";
import GoogleAuth from "./components/googleAuthProvider";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <GoogleAuth>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </GoogleAuth>
    </Provider>
);